function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { rgba } from 'polished';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import Alert from '../icons/solid/Alert';
import CancelCircle from '../icons/solid/CancelCircle';
import CheckCircle from '../icons/solid/CheckCircle';
import Info from '../icons/solid/Info';
import withSpacing from '../lib/hoc/withSpacing';
import { margin, padding, shade, themify, tint } from '../styles/mixins';
import { curves, z } from '../styles/theme';
import { Card } from './Card';
import { Icon } from './Icon';
const StyledToast = styled(Card).withConfig({
  displayName: "Toast__StyledToast",
  componentId: "fbs9fv-0"
})(["", ";", ";display:flex;align-items:center;background:", ";border-left:3px solid ", ";border-radius:", ";color:", ";width:", ";font-size:", ";pointer-events:all;transition:all 0.15s ", ";z-index:", ";cursor:", ";transition-delay:", ";&:hover{opacity:", ";}"], padding(2), margin(2, 'b'), x => x.$mobile ? rgba(tint(0.5, x.$color), 0.95) : rgba(tint(0.3, x.$color), 0.75), x => x.$color, x => x.$mobile ? 0 : '6px', x => shade(0.75, x.$color), x => x.$mobile ? '100%' : x.$width, x => x.theme.type.scale[x.$fontSize], curves.standard, x => x.$zIndex, x => x.$clickable ? 'pointer' : 'default', x => x.$duration ? `${x.$duration / 2}ms` : 'unset', x => x.$clickable ? 0.5 : 1);
const ToastIconWrapper = styled.div.withConfig({
  displayName: "Toast__ToastIconWrapper",
  componentId: "fbs9fv-1"
})(["", ";display:inline-block;min-width:18px;& svg{background:white;border-radius:100px;}"], margin(2, 'r'));

function parseToastType(type) {
  let color, icon;

  switch (type) {
    case 'error':
      color = 'red';
      icon = CancelCircle;
      break;

    case 'alert':
      color = 'orange';
      icon = Alert;
      break;

    case 'warning':
      color = 'orange';
      icon = Alert;
      break;

    case 'success':
      color = 'green';
      icon = CheckCircle;
      break;

    case 'info':
      color = 'blue';
      icon = Info;
      break;

    default:
      color = 'grayDark';
      icon = Info;
  }

  return {
    color,
    icon
  };
}

export const ToastFunc = (_ref) => {
  let {
    duration = 5000,
    fontSize = 5,
    handleClose,
    message = '???',
    mobile,
    onClick,
    type = 'info',
    width = '288px',
    zIndex = z.toast
  } = _ref,
      cardProps = _objectWithoutProperties(_ref, ["duration", "fontSize", "handleClose", "message", "mobile", "onClick", "type", "width", "zIndex"]);

  useEffect(() => {
    if (typeof duration === 'number' && duration > 0 && handleClose) {
      setTimeout(handleClose, duration);
    }
  }, [duration, handleClose]);
  return /*#__PURE__*/React.createElement(StyledToast, _extends({
    animation: "none",
    $clickable: Boolean(onClick || handleClose),
    $color: themify(parseToastType(type).color),
    $fontSize: fontSize,
    $mobile: !!mobile,
    onClick: () => {
      onClick == null ? void 0 : onClick();
      handleClose == null ? void 0 : handleClose();
    },
    $width: width,
    $duration: duration,
    $zIndex: zIndex
  }, cardProps), /*#__PURE__*/React.createElement(ToastIconWrapper, null, /*#__PURE__*/React.createElement(Icon, {
    icon: parseToastType(type).icon,
    solid: true,
    inline: true,
    fill: parseToastType(type).color,
    width: "18px",
    height: "18px"
  })), message);
};
export const Toast = withSpacing(ToastFunc);